import axios from './abstract.service';

export const GetListFollowPairs = (params: any): any => axios.get('follow-pairs', { params }).then(res => res);
export const updateFollowPairStatus = (params: any): any => axios.post('follow-pairs/update-status', params).then(res => res);

export const updateFollowPairAutoEnable = (params: any): any => axios.post('follow-pairs/update-auto-status', params).then(res => res);

export const createFollowPair = (params: any): any => axios.post('follow-pairs', params).then(res => res);

export const deleteFollowPairs = (params: any): any => axios.delete('follow-pairs', { params }).then(res => res);
